// import './modules/external-link';
import './modules/safari-fix';
import './modules/main-menu';
import './modules/scroll-to';
import './modules/buttons';
import './modules/skip-link';
import './modules/back-to-top';
import './modules/in-page-alert';
import './modules/tables';
import './modules/accordion';
import './modules/forms';
import './modules/media-carousel';
import './modules/basic-page';
import './modules/listing-page';
import './modules/search-listing';
import './modules/content-card-carousel';
import './modules/on-this-page';
// import './modules/animations';
import './modules/video';
import './modules/fund-sticky-navigation';
import './modules/fund-variant-dropdown';
import './modules/statistics-panel';
import './modules/card-left-right-carousel';
import './modules/investment-solutions-card';
import './modules/is-feed-carousel';
import './modules/reading-progress-indicator';
// import './modules/brand-transition';
